export enum PermissionType {
  Admin = 'accesso_admin',
  OfficesHierarchy = 'gerarchia_uffici',
  ExternalOrganigram = 'organigramma_esterno',
  CreateProcedure = 'crea_procedimento',
  Intermediation = 'gestione_intermediari',
  TestinAccess = 'accesso_collaudo',
  ShowDocumentalDossier = 'visualizzazione_fascicolo',
  ShowProtocolData = 'visualizza_dati_protocollo',
  ShowPhaseFilter = 'visualizza_filtro_fase',
  ShowSubprocedureState = 'visualizza_stato_endoprocedimenti',
  ShowDossier = 'visualizza_pratica',
  VerifySignatureBook = 'verifica_libro_firma',
  VerticalManagement = 'gestione_verticale',
  AssignTask = 'assegna_task',
  ViewTask = 'visualizza_task',
  EditDeadlineColor = 'modifica_colore_scadenza',
  CsvMassiveExtraction = 'estrazione_massiva_csv',
  DownloadProcedureHistory = 'download_cronologia_procedimento',
  ConfigureRegimes = 'configurazione_regimi',
  AssignInstance = 'ass_istanza',
}
